/** Coin-sheet link for a coin pair, including legacy's mirror-pair swap
 * (`coinPair`/`coin1`/`coin2` containing `*`: the link target swaps the two
 * coins and strips the `*`, per the legacy page spec). */
export function coinSheetLink(exchangeId: string, coin1: string, coin2: string): string {
  const mirror = coin1.includes('*') || coin2.includes('*')
  if (!mirror) return `/${exchangeId}/spot/coins/${coin1}/${coin2}`
  return `/${exchangeId}/spot/coins/${coin2.replace('*', '')}/${coin1.replace('*', '')}`
}

export function pairLabel(coin1: string, coin2: string): string {
  return `${coin1}${coin2}`
}
